module.exports = __webpack_public_path__ + "static/img/pdf.939449c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/chat_files/pdf.png
// module id = 9Z7U
// module chunks = 4